import { TreeNode } from "./interfaces";

export const makeTree = <T extends { tag: string }>(items: T[]) => {
    const tree: TreeNode<T> = {
        tag: "$root",
        children: [],
    };

    for (const item of items) {
        const parts = item.tag.split(".");
        let current = tree;

        for (let i = 0; i < parts.length - 1; ++i) {
            let next = current.children.find((child) => child.tag === parts[i]);

            if (!next) {
                next = {
                    tag: parts[i],
                    children: [],
                };

                current.children.push(next);
            }

            current = next;
        }

        current.children.push({
            tag: parts[parts.length - 1],
            children: [],
            value: item,
        });
    }

    return tree;
};
